import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M16.7992 12.0504C13.598 10.8259 12.9038 10.1987 12.2135 6.59998C11.2387 10.1987 10.4005 10.8222 7.19922 12.0504C10.4005 13.0957 11.1249 13.8012 12.0656 17.4C12.8963 13.8012 13.598 13.0957 16.7992 12.0504Z",
      fill: "#FFB107"
    }, null, -1)
  ]))]))
}
export default { render: render }